import { FC } from 'react';
import TrainingJumpSentence from '../Modecules/TrainingJumpSentence';
import { TrainingInfoSentences } from '../../types/apis/trainingInfoApi';
import { TOPIC_SENTENCE_ID } from '../../utils/const';

import styles from './TrainingSentences.module.scss';

type Props = {
  // センテンスのデータ
  sentenceData: TrainingInfoSentences[];
  // 現在の再生時間
  currentTime: number;
};

const TrainingJumpSentences: FC<Props> = ({ sentenceData, currentTime }) => {
  const sentencesComponent = () => {
    // 最初のセンテンスの開始時間
    const firstStartTime =
      sentenceData.length !== 0 ? sentenceData[0].english.start : 0;

    return sentenceData.map((item) => (
      <TrainingJumpSentence
        key={item.english.id}
        currentTime={currentTime}
        englishSentence={{
          text: item.english.text,
          endTime: item.english.end,
        }}
        firstSentenceStartTime={firstStartTime}
        isTopic={item.english.id === TOPIC_SENTENCE_ID}
      />
    ));
  };

  return (
    <div
      className={`${styles['training-sentences']} ${styles['mod-training']}`}
    >
      <div className={styles['training-sentences-outer']}>
        {sentencesComponent()}
      </div>
    </div>
  );
};

export default TrainingJumpSentences;
